import React from 'react';
import { DivorceContent } from './DivorceContent';

export const Divorce = () => {
  return (
    <div className="divorce">
      <div className="divorce-heading">
        <p>РОЗІРВАННЯ ШЛЮБУ</p>
      </div>
      <div className="service-packages">
        <div className="service-package">
          <div className="info-heading desktop">
            <p>
              ПАКЕТ <br />
              «МІНІМАЛЬНИЙ»
            </p>
          </div>
          <DivorceContent packageName="min" />
        </div>
        <div className="service-package">
          <div className="info-heading desktop">
            <p>
              ПАКЕТ «ПІД КЛЮЧ, <br />
              БЕЗ ВАШОЇ УЧАСТІ»
            </p>
          </div>
          <DivorceContent packageName="max" />
        </div>
        <div className="service-package">
          <div className="info-heading desktop">
            <p>
              ПАКЕТ <br />
              «ОПТИМАЛЬНИЙ»
            </p>
          </div>
          <DivorceContent packageName="mid" />
        </div>
      </div>
      <div className="info-price">
        <p>1000грн</p>
        <p>3500грн</p>
        <p>2000грн</p>
      </div>
    </div>
  );
};
